module.exports = __webpack_public_path__ + "static/img/pic1@2x2.b74c8c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/liveimg/pic1@2x2.png
// module id = 6+8N
// module chunks = 1